<template>
<div>
    <div class='override-class' style='{ margin: "20px"}'>
    <h1> Application examples </h1>
    <v-container fluid>
      <v-col cols='6'>
        <v-select
        v-model='user_story'
        :items='items2'
        item-text='user_story'
        item-value='abbr'
        label='Select'
        persistent-hint
        return-object
        single-line
        outlined
        v-on:change='clear_plots()'
        ></v-select>
      </v-col>
    </v-container>
  <div v-if='this.user_story.user_story === "Data usage"'>
    <h2> Overview of metadata sheets </h2>
    <v-btn @click='update_data' color='success'> Update / add plot </v-btn>
    <v-btn @click='remove_plot' color='red'> Remove plot </v-btn>
  </div>
  <div v-else-if='this.user_story.user_story === "Sciebo usage"'>
    <h2> Sciebo data usage </h2>
    <v-btn @click='update_sciebo' color='success'> Update / add plot </v-btn>
    <v-btn @click='remove_plot' color='red'> Remove plot </v-btn>
  </div>
  <div v-else-if='this.user_story.user_story === "Data management"'>
    <h2> Access raw and processed data </h2>
    <v-select
    v-model='selected_data'
    :items="['Processed', 'Raw']"
    hint='Pick your data'
    label='Selected datasets'
    multiple
    clearable
    chips
    autowidth></v-select>
    <v-btn @click='update_data' color='success'> Update / add plot </v-btn>
    <v-btn @click='reset_data'  color='red'> Remove data </v-btn>
    <h2 v-if="this.processedDataFiles !== ''"> Raw data </h2>
    <div class="response" v-html="processedDataFiles"/>
    <h2 v-if="this.rawprocessedDataFiles !== ''"> Processed data </h2>
    <div class="response" v-html="rawprocessedDataFiles"/>
  </div>
  <div v-else>
    <h2> Summary statistics</h2>
    <v-btn @click='update_data' color='success'> Update / add plot </v-btn>
    <v-btn @click='remove_plot' color='red'> Remove plot </v-btn>
    <v-container fluid>
      <v-col cols='6'>
        <v-select
          v-model='select'
          chips
          :hint='`List ${select.comp_group}`'
          :items='items'
          item-text='comp_group'
          item-value='abbr'
          label='Select'
          persistent-hint
          return-object
          single-line
          outlined
          v-on:change='update_data()'
        ></v-select>
      </v-col>
  </v-container>
  <v-container fluid>
      <v-col cols='6'>
        <v-select
          v-model='plot_type'
          :hint='`Type of plot`'
          :items='items3'
          item-text='plot_type'
          item-value='abbr'
          label='Select'
          persistent-hint
          return-object
          single-line
          outlined
          v-on:change='update_data()'
        ></v-select>
      </v-col>
  </v-container>
  </div>
<template v-for="(child, index) in plots">
 <component :is="child['plot_type']" :key="index" :title="child.plot.title" :layouts="child.plot.layouts" :type="child.plot.plot_type" :datas="child.plot.datas"/>
</template>
</div>
</div>
</template>

<script>
import QueryService from '@/services/QueryService'
import PlotlyMain from '@/components/PlotlyComponent.vue'
import PlotlyAlternative from '@/components/PlotlyAlternativeComponent.vue'

export default {
  components: { PlotlyAlternative, PlotlyMain },
  name: 'UserStories',
  data () {
    return {
      processedDataFiles: '',
      rawprocessedDataFiles: '',
      plots: [],
      names: [],
      selected_data: '',
      mapping: { 'Scatterplot': 'scatter', 'PieChart': 'pie', 'Histogram': 'hist', 'BarChart': 'bar' },
      select: { comp_group: 'Ages', abbr: 'Ages' },
      user_story: { user_story: 'Data usage', abbr: 'Usage' },
      plot_type: { plot_type: 'PieChart', abbr: 'PieChart' },
      items: [
        { comp_group: 'Treatments', abbr: 'Treatments' },
        { comp_group: 'Diets', abbr: 'Diets' },
        { comp_group: 'Ages', abbr: 'Ages' },
        { comp_group: 'Others', abbr: 'Others' },
        { comp_group: 'Genotypes', abbr: 'Genotypes' },
        { comp_group: 'Procedures', abbr: 'Procedures' },
        { comp_group: 'Measurements', abbr: 'Measurements' },
        { comp_group: 'Temperatures', abbr: 'Temperatures' },
        { comp_group: 'Cells', abbr: 'Cells' },
        { comp_group: 'TimeSeries', abbr: 'TimeSeries' },
        { comp_group: 'ExperimentalSystem', abbr: 'ExperimentalSystem' },
        { comp_group: 'Overview', abbr: 'Overview' },
        { comp_group: 'DateTitleGroup', abbr: 'DateTitleGroup' }
      ],
      items2: [
        { user_story: 'Summary statistics', abbr: 'Summary' },
        { user_story: 'Data usage', abbr: 'Usage' },
        { user_story: 'Data management', abbr: 'Data' },
        { user_story: 'Sciebo usage', abbr: 'Sciebo' }
      ],
      items3: [
        { plot_type: 'Histogram', abbr: 'Histogram' },
        { plot_type: 'Scatterplot', abbr: 'Scatterplot' },
        { plot_type: 'PieChart', abbr: 'PieChart' },
        { plot_type: 'BarChart', abbr: 'BarChart' }
      ]
    }
  },
  methods:
  {
    hexToRgb (hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
      var temp = result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null
      return `rgb(${temp.r},${temp.g},${temp.b})`
    },
    sort_dates (dates) {
      dates.sort(function (a, b) {
        var aa = a.split('-')
        var bb = b.split('-')
        var atemp = [aa[0], aa[2], aa[1]].join()
        var btemp = [bb[0], bb[2], bb[1]].join()
        return atemp < btemp ? -1 : (atemp > bb ? 1 : 0)
      })
      return dates
    },
    unique_random_numbers_in_interval (low, high, num) {
      var arr = []
      while (arr.length < num) {
        var r = Math.floor(Math.random() * high) + low
        if (arr.indexOf(r) === -1) { arr.push(r) }
      }
      return arr
    },
    get_colors () {
      return [
        '#00ffff', // aqua
        '#f0ffff', // azure
        '#0000ff', // blue
        '#a52a2a', // brown
        '#00ffff', // cyan
        '#00008b', // darkblue
        '#008b8b', // darkcyan
        '#a9a9a9', // darkgrey
        '#006400', // darkgreen
        '#bdb76b', // darkkhaki
        '#8b008b', // darkmagenta
        '#556b2f', // darkolivegreen
        '#ff8c00', // darkorange
        '#9932cc', // darkorchid
        '#8b0000', // darkred
        '#e9967a', // darksalmon
        '#9400d3', // darkviolet
        '#ff00ff', // fuchsia
        '#ffd700', // gold
        '#008000', // green
        '#4b0082', // indigo
        '#f0e68c', // khaki
        // '#add8e6', // lightblue
        // '#e0ffff', // lightcyan
        // '#90ee90', // lightgreen
        // '#d3d3d3', // lightgrey
        // '#ffb6c1', // lightpink
        // '#ffffe0', // lightyellow
        '#00ff00', // lime
        '#ff00ff', // magenta
        '#800000', // maroon
        '#000080', // navy
        '#808000', // olive
        '#ffa500', // orange
        '#ffc0cb', // pink
        '#800080', // purple
        '#800080' // violet
        // '#ff0000', // red
        // '#c0c0c0', // silver
        // '#ffff00', // yellow
      ]
    },
    remove_plot () {
      this.plots.pop()
    },
    async clear_plots () {
      this.plots = []
      // Add plot automatically
      // this.update_data()
    },
    // //////////////////////////////////////////////////////////////////////////
    // /// update_data //////////////////////////////////////////////////////////
    // //////////////////////////////////////////////////////////////////////////
    async update_data () {
      var data
      if (this.user_story.user_story === 'Data management') {
        data = this.get_files()
      } else if (this.user_story.user_story === 'Data usage') {
        data = this.get_data('Usage')
      } else if (this.user_story.user_story === 'Sciebo usage') {
        data = this.get_sciebo()
      } else {
        if (this.select.comp_group === 'Overview') {
          data = this.get_data_for_overview()
        } else if (this.select.comp_group === 'DateTitleGroup') {
          data = this.get_data_for_date_title_and_group()
        } else {
          data = this.get_data(this.select.comp_group)
        }
      }

      if (this.select.comp_group === 'TimeSeries') {
        const response = await QueryService.query({
          queryType: 'TimeSeries'
        }, this.$store.getters.isLoggedIn) // isLoggedIn provides Bearer access token after login for private resources
        var traces = []
        var allxs = []
        var allindices = []
        var alllabels = []
        var allstarts = []
        response.data.forEach(function (item, index) {
          var timestamps = []
          var start = []
          var end = []
          var indices = []
          var labels = []
          var infos = []
          item.forEach(function (item2, index2) {
            timestamps.push(item2['name'])
            end.push(item2['end'])
            start.push(item2['start'])
            infos.push(item2['comment'])
          })
          var uniqueTimestamps = [...new Set(timestamps)]
          timestamps.forEach(function (item3, index3) {
            indices.push(uniqueTimestamps.indexOf(item3))
            labels.push(item3)
          })
          var x = [...Array(timestamps.length).keys()]
          allxs = allxs.concat(x)
          allindices = allindices.concat(indices)
          alllabels = alllabels.concat(labels)
          allstarts = allstarts.concat(start)
          traces.push({x: x, y: indices, type: 'scatter', mode: 'lines+markers', name: `Timeline ${index + 1}`})
        })
        var layout = { scattermode: 'group', yaxis: { tickmode: 'array', tickvals: allindices, ticktext: alllabels }, xaxis: { tickmode: 'array', tickvals: allxs, ticktext: allstarts } }
        this.plots.push({'plot': { 'title': 'Time series', datas: traces, layouts: layout }, 'plot_type': 'PlotlyAlternative'})
      } else {
        var counts = []
        var names = []
        data.then((res) => {
          res.counts.forEach((item, index) => {
            counts.push(item)
          })
          res.names.forEach((item, index) => {
            names.push(item)
          }
          )
        })

        var groups = []
        if (this.select.comp_group === 'DateTitleGroup') {
          data.then((res) => {
            res.groups.forEach((item, index) => {
              groups.push(item)
            })
          })
        }

        var chosenTitle = this.select.comp_group
        if (this.select.comp_group === 'DateTitleGroup') {
          chosenTitle = 'Overview of metadata sheets in database'
          this.plots.push({'plot': { 'title': this.user_story.user_story === 'Data usage' ? 'Data usage' : chosenTitle, datas: [ { 'x': counts, 'y': names, values: groups, text: groups, labels: groups, type: this.mapping[this.plot_type.plot_type] } ] }, 'plot_type': 'PlotlyMain'})
        } else if (this.user_story.user_story === 'Data management') {
          // Nothing to plot in case of data management
        } else {
          this.plots.push({'plot': { 'title': this.user_story.user_story === 'Data usage' ? 'Data usage' : chosenTitle, datas: [ { 'x': counts, 'y': names, values: counts, labels: names, type: this.mapping[this.plot_type.plot_type] } ] }, 'plot_type': 'PlotlyMain'})
        }
      }
    },
    // //////////////////////////////////////////////////////////////////////////
    // /// get_data /////////////////////////////////////////////////////////////
    // //////////////////////////////////////////////////////////////////////////
    async get_data (queryType) {
      const response = await QueryService.query({
        queryType: queryType
      }, this.$store.getters.isLoggedIn) // isLoggedIn provides Bearer access token after login for private resources
      var names = []
      var counts = []
      response.data.forEach(function (item, index) {
        names.push(item['name'])
      })
      var uniqueNames = [...new Set(names)]
      uniqueNames.forEach(function (item, index) {
        counts.push(names.filter(x => x === item).length)
      })
      names = [...new Set(names)]
      return {names: names, counts: counts}
    },
    // //////////////////////////////////////////////////////////////////////////
    // /// get_data_for_date_title_and_group ////////////////////////////////////
    // //////////////////////////////////////////////////////////////////////////
    async get_data_for_date_title_and_group () {
      const response = await QueryService.query({
        queryType: 'DateTitleGroup'
      }, this.$store.getters.isLoggedIn) // isLoggedIn provides Bearer access token after login for private resources
      var dates = []
      var titles = []
      var groups = []
      response.data.forEach(function (item, index) {
        dates.push(item['date'])
        titles.push(item['title'])
        groups.push(item['group'])
      })
      var counts = []
      var uniqueNames = [...new Set(dates)]
      uniqueNames.forEach(function (item, index) {
        counts.push(dates.filter(x => x === item).length)
      })
      var names = [...new Set(dates)]
      var countsFinal = []
      names.forEach(function (elem, index) {
        // this[index] = elem.replace('T00:00:00', '')
        countsFinal.push(counts[index])
      }, names
      )
      const cumulativeSum = (sum => value => sum += value)(0) // eslint-disable-line
      names = this.sort_dates(names)
      countsFinal = countsFinal.map(cumulativeSum)
      /// Temp for Fenske bad date
      names.shift()
      names.unshift('2022-10-20T00:00:00')
      /// Also Pfeifer bad date
      return {counts: names, names: countsFinal, groups: groups} // # Array.from({length: counts.length}, (_, i) => i + 1)}
    },
    // //////////////////////////////////////////////////////////////////////////
    // /// get_data_for_overview ////////////////////////////////////////////////
    // //////////////////////////////////////////////////////////////////////////
    async get_data_for_overview () {
      const compGroups = ['Diets', 'Treatments', 'Genotypes', 'Temperatures', 'Ages', 'Others']
      var finalNames = []
      var finalCounts = []
      await Promise.all(compGroups.map(async (group) => {
        var names = []
        var counts = []
        const response = await QueryService.query({
          queryType: group
        }, this.$store.getters.isLoggedIn) // isLoggedIn provides Bearer access token after login for private resources
        response.data.forEach(function (item, index) {
          names.push(item['name'])
        })
        var uniqueNames = [...new Set(names)]
        uniqueNames.forEach(function (item, index) {
          counts.push(names.filter(x => x === item).length)
        })
        names = [...new Set(names)]
        finalNames.push(group)
        finalCounts.push(counts.length)
      }))
      return {names: finalNames, counts: finalCounts}
    },
    // //////////////////////////////////////////////////////////////////////////
    // /// get_files ////////////////////////////////////////////////////////////
    // //////////////////////////////////////////////////////////////////////////
    async get_files () {
      var chosenData = this.selected_data.length === 1 ? [this.selected_data[0], this.selected_data[0]] : this.selected_data
      var allLocations = []
      var allSheets = []
      var allStorages = []
      var allComments = []
      await Promise.all(chosenData.map(async (group) => {
        var location = []
        var sheet = []
        var storage = []
        var comment = []
        const response = await QueryService.query({
          queryType: group.concat('Data')
        }, this.$store.getters.isLoggedIn) // isLoggedIn provides Bearer access token after login for private resources

        response.data.forEach(function (item, index) {
          location.push(item['location'])
          sheet.push(item['sheet'])
          storage.push(item['storage'])
          comment.push(item['comment'])
        })
        allLocations.push(location)
        allSheets.push(sheet)
        allStorages.push(storage)
        allComments.push(comment)
      }))

      var htmlResponseRaw = `
        <table>
        <tr>
        <th> Sheet name </th>
        <th> Raw data location </th>
        <th> Link type Personal ID to data </th>
        <th> Comment </th>
        </tr>
      `
      allSheets[0].forEach(function (item, index) {
        htmlResponseRaw = htmlResponseRaw.concat(`<tr> <td> ${item} </td>`)
        htmlResponseRaw = htmlResponseRaw.concat(`<td> ${allLocations[0][index]} </td>`)
        htmlResponseRaw = htmlResponseRaw.concat(`<td> ${allComments[0][index]} </td>`)
        htmlResponseRaw = htmlResponseRaw.concat(`<td> ${allStorages[0][index]} </td> </tr>`)
      })

      var htmlResponseProcessed = `
        <table>
        <tr>
        <th> Sheet name </th>
        <th> Processed data location </th>
        <th> Link type Personal ID to data </th>
        <th> Comment </th>
        </tr>
      `
      allSheets[1].forEach(function (item, index) {
        htmlResponseProcessed = htmlResponseProcessed.concat(`<tr> <td> ${item} </td>`)
        htmlResponseProcessed = htmlResponseProcessed.concat(`<td> ${allLocations[1][index]} </td>`)
        htmlResponseProcessed = htmlResponseProcessed.concat(`<td> ${allComments[1][index]} </td>`)
        htmlResponseProcessed = htmlResponseProcessed.concat(`<td> ${allStorages[1][index]} </td> </tr>`)
      })

      htmlResponseRaw = htmlResponseRaw.concat(`</table>`)
      htmlResponseProcessed = htmlResponseProcessed.concat(`</table>`)
      this.rawprocessedDataFiles = htmlResponseProcessed
      this.processedDataFiles = htmlResponseRaw
      if (this.selected_data.length === 1) {
        if (this.selected_data === 'RawData') {
          this.rawprocessedDataFiles = ''
        } else {
          this.processedDataFiles = ''
        }
      }
    },
    // //////////////////////////////////////////////////////////////////////////
    // /// reset_data ///////////////////////////////////////////////////////////
    // //////////////////////////////////////////////////////////////////////////
    async reset_data () {
      this.processedDataFiles = ''
      this.rawprocessedDataFiles = ''
      this.selected_data = ''
    },
    async update_sciebo () {
      const response = await QueryService.query({
        queryType: 'Sciebo'
      }, this.$store.getters.isLoggedIn) // isLoggedIn provides Bearer access token after login for private resources
      var mydata = response.data
      var files = []
      var usages = []
      var names = []
      for (let i = 0; i < mydata['projects'].length; i++) {
        files.push(mydata.projects[i]['files'])
        usages.push(mydata.projects[i]['usage'] / 1000)
        names.push(mydata.projects[i]['name'])
      }
      var layoutsFiles = {
        title: {
          text: 'Files stored in project boxes'
        },
        xaxis: {
          title: {
            text: 'Sciebo Project box'
          }
        },
        yaxis: {
          title: {
            text: 'Files [#]'
          }
        }
      }
      var layoutsUsage = {
        title: {
          text: 'Data stored in project boxes'
        },
        xaxis: {
          title: {
            text: 'Sciebo Project box'
          }
        },
        yaxis: {
          title: {
            text: 'Disk space [MiB]'
          }
        }
      }
      var colors = this.unique_random_numbers_in_interval(0, this.get_colors().length, names.length).map(x => this.hexToRgb(this.get_colors()[x]))
      this.plots.push({'plot': { layouts: layoutsFiles, datas: [ { 'marker': { color: colors }, 'x': names, 'y': files, values: files, text: files, labels: files, type: 'bar' } ] }, 'plot_type': 'PlotlyAlternative'})
      this.plots.push({'plot': { layouts: layoutsUsage, datas: [ { 'marker': { color: colors }, 'x': names, 'y': usages, values: usages, text: usages, labels: usages, type: 'bar' } ] }, 'plot_type': 'PlotlyAlternative'})
    }
  },
  mounted () {
    // Add plot automatically
    // this.get_data(queryType)
    /*
    console.log('get ages')
    this.get_ages().then((results) => {
      console.log('create plot')
      this.create_plot(results)
    })
    */
  }
}
</script>



// WEBPACK FOOTER //
// src/views/UserStoriesComponent.vue